/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import { Typography } from 'fronton-react';
import { css } from 'linaria';
import { useTranslation } from 'react-i18next';
import { patchUrlByLocale } from 'utils';

type PersonalDataAgreementProps = {
  personalLinkHref: string;
  reviewRulesHref: string;
};

export const PersonalDataAgreement: React.FC<PersonalDataAgreementProps> = ({
  personalLinkHref,
  reviewRulesHref,
}) => {
  const { t } = useTranslation();
  return (
    <Typography variant="caption" color="text-minor">
      {t('reviews.form.data-agreement.part1')}
      <a className={dataLinks} href={patchUrlByLocale(personalLinkHref)} target="_blank" rel="noopener">
        {t('reviews.form.data-agreement.part2')}
      </a>
      {t('reviews.form.data-agreement.part3')}
      <a className={dataLinks} href={patchUrlByLocale(reviewRulesHref)} target="_blank" rel="noopener">
        {t('reviews.form.data-agreement.part4')}
      </a>
      {t('reviews.form.data-agreement.part5')}
    </Typography>
  );
};

const dataLinks = css`
  margin-right: 5px;
  margin-left: 5px;
  color: var(--text-minor);
  transition: 0.2s ease-out;
  &:hover {
    color: var(--brand-dark);
  }
`;
